'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import iconsSRC from 'icons.svg'; Now Using AJAX call to import icons.svg sprite. Check the icons readme.
var Icon = function Icon(props) {
    var _classnames;

    var size = props.size,
        color = props.color,
        className = props.className,
        ariaHidden = props.ariaHidden,
        title = props.title,
        name = props.name,
        spanDescription = props.spanDescription;

    var iconClassNames = (0, _classnames3.default)('luna-icon', className, (_classnames = {}, _defineProperty(_classnames, 'luna-icon--' + size, size), _defineProperty(_classnames, 'luna-icon--' + color, color), _classnames));
    return _react2.default.createElement("svg", { className: iconClassNames, "aria-hidden": ariaHidden, title: title }, _react2.default.createElement("use", { xlinkHref: '#' + name }), _react2.default.createElement("span", { className: "u-screenReader" }, spanDescription));
};
Icon.propTypes = {
    name: _propTypes2.default.string.isRequired,
    size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large']).isRequired,
    color: _propTypes2.default.oneOf(['primary', 'success', 'error']).isRequired,
    title: _propTypes2.default.string.isRequired,
    spanDescription: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string.isRequired,
    ariaHidden: _propTypes2.default.bool.isRequired
};
exports.default = Icon;
//# sourceMappingURL=Icon.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Icon/Icon.js